import type { FaireProductEntity } from "../../entity_types/product";

export const p_y25vykkt6u: FaireProductEntity = {
  token: "p_y25vykkt6u",
  type: "product",
  name: "Case-Mate Mahjong Jelly Tote Set",
  brandToken: "b_7dpvor9hnj",
  brandName: "Case-Mate",
  imageUrl:
    "https://cdn.faire.com/fastly/7ea1979ef5c49762492adf2898199b867115d2415343c6a01662496908930217.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/44f6a3f2d51e396465d5ed6f45810133d54e3107025b8a108cc2514dd25c0dc0.jpeg",
    "https://cdn.faire.com/fastly/3942c4b0f2443cdaa2e7c5fdfac82b5c75be3155141e67c639a19974e2eff964.jpeg",
    "https://cdn.faire.com/fastly/47e0a6439260855e8b160be145a99e2bc65401efd780c637d5184404ed296387.jpeg",
    "https://cdn.faire.com/fastly/f94fd73bd446544881264becc9112d77c98144329e7146ef34587d331c63a83a.jpeg",
    "https://cdn.faire.com/fastly/35b4c97cc44fdc1b335dfa96da8fb03684f81cdd64de6c5ec0574d1a5b7e9a3e.jpeg",
    "https://cdn.faire.com/fastly/6d035a52240299fe9d8fdf27172563cde0706f930bd280d75785da5d9cf484d7.jpeg",
    "https://cdn.faire.com/fastly/761d952698c4ef78f9c65eabccca327c96d033fb39f3545bc85c51f431b8fee5.jpeg",
  ],
  priceDollars: 75,
  description:
    "Everything your game needs, thoughtfully designed and ready to go. The Mahjong Jelly Tote Set includes an extra-large Jelly Tote to fit your entire set comfortably, a dedicated game card and dice pouch, a protective rack sleeve, and a crinkle tile bag that holds an entire tile set. Every piece works together to keep your set organized, protected, and easy to carry. Whether you're headed to a friend's or your next game night out, this four-piece mahjong bag set makes it easy to pack up and go without leaving anything behind. When your game is done, store everything neatly in the Jelly Tote until you’re ready to play again!\n\n*Game pieces not included.\n",
  tags: [],
  msrpDollars: 150,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:45.788Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
